import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreLoadingComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { MapfreModalComponent } from '../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { WidgetContent } from '@models/widget/widget-content.interface';
import { ClaimsService } from '@services/_claims/claims.service';
import{ NavigationService } from '@services/navigation.service';
import { ActionType } from '@models/widget/action-type.enum';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreLoadingComponent, MapfreButtonComponent],
  selector: 'app-policy-selector-widget',
  templateUrl: './policy-selector-widget.component.html',
  styleUrls: ['./policy-selector-widget.component.css'],
})
export class PolicySelectorWidgetComponent implements OnInit{
  @Input() widgetContent: WidgetContent
  policySelectorModal: ModalOptions;
  policyList: any[];
  isAcmic: boolean;
  hideModalOnRoute: boolean;
  isLoading: boolean;
  isOpenModal: boolean;

  constructor(       
      private claimsService: ClaimsService,     
      private acmicService: AcmicService,
      private policyDataService: PolicyDataService,
      private router: Router,
      private navService: NavigationService
    ){}

  public ngOnInit() {
    this.isLoading = true;
    this.isAcmic = this.acmicService.isACMIC();
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        this.policyList = policyResponse;
        this.isLoading = false;
      }
    });
  }

  public onClick() {
    if (this.policyList?.length === 1) {
      this.handleClick(this.policyList[0]);
    } else {
      this.onLoadModal();
    }
  }

   onLoadModal() {
    this.isOpenModal = true;

    this.policySelectorModal = new ModalOptions({
      modalId: this.widgetContent.id,
      onLoad: true,
      additionalClasses: 'modal-medium modal-dialog modal-center-on-page modal-dialog-scrollable upload-document-modal',
      modalName: this.widgetContent.label,
    });
  }

  handleClick(policy: any){
    this.navService.saveCurrentAction(this.widgetContent.type);
    if(this.widgetContent.type === ActionType.ReportClaim){
      this.claimsService.setClaimURL(policy);
      const url = this.router.serializeUrl(this.router.createUrlTree(this.widgetContent.route))
      window.open(url, '_blank');
    }else{
      this.redirect(policy.policynumber.policyNumber);
    }
  }

  redirect(policyNumber: string){
    const policyPlace = this.widgetContent.route.indexOf("");    
    const route = [...this.widgetContent.route];
    route[policyPlace] = policyNumber;
    this.router.navigate(route);
  }

  hideModal(event) {
    void event;
    this.hideModalOnRoute = !this.hideModalOnRoute; 
    this.isOpenModal = false;
  }

}
